import { render, staticRenderFns } from "./KingdomBuildBoard.vue?vue&type=template&id=62072b2e&scoped=true"
import script from "./KingdomBuildBoard.vue?vue&type=script&lang=js"
export * from "./KingdomBuildBoard.vue?vue&type=script&lang=js"
import style0 from "./KingdomBuildBoard.vue?vue&type=style&index=0&id=62072b2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62072b2e",
  null
  
)

export default component.exports